import { render } from "./TungstenFabricPolicyRule.vue?vue&type=template&id=74872be3"
import script from "./TungstenFabricPolicyRule.vue?vue&type=script&lang=js"
export * from "./TungstenFabricPolicyRule.vue?vue&type=script&lang=js"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__